import React, { Component } from 'react';

import ModernCalendar from '../../Mobile/Calendar/Calendar';
import CalendarHeader from '../../Mobile/CalendarHeader/CalendarHeader';

import left from '../../../../assets/icons/left.svg';
import right from '../../../../assets/icons/right.svg';

import './DesktopCalendar.css';

export default class DesktopCalendar extends Component {
  render() {
    const { setSelectedDay, selectedDay, monasebat } = this.props;
    return (
      <div className="desktop-calendar d-flex flex-column">
        <div className="desktop-calendar__top"></div>
        <div className="desktop-calendar__middle  pt-4">
          <CalendarHeader date={selectedDay} />
          <ModernCalendar headerAccess={false} weekAccess={true} setSelectedDay={setSelectedDay} />
          <div className="calendar-left d-flex">
            <img src={left} />
          </div>
          <div className="calendar-right d-flex">
            <img src={right} />
          </div>
          <div className="mobile-home__top--events d-flex flex-column">
            {
              monasebat.map(item => (
                <div key={item.id} style={{ borderColor: item.color }} className="d-flex">
                  <span style={{ border: "2px solid" + item.color, borderRadius: 2, backgroundColor: item.color }}></span>
                  <div className="mt-1">{item.name}</div>
                </div>
              ))
            }
          </div>
        </div>
        <div className="desktop-calendar__bottom"></div>
      </div>
    );
  }
}